
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


var DefaultTodoPage = Vue.extend({})
Vue.component('defaultTodo-page', DefaultTodoPage)

export default {
  name: 'DefaultTodoPage',
  components: {
    XTable, XButton
  },
  props: {
    idArr: Array
  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      content: []
    }
  },
  mounted () {
    const url = this.baseUrl + '/wechat/otherBusiness/' + this.idArr[0] + '/info?flowId=' + this.idArr[1]
    this.axios({
      url: url,
      method: 'get'
    }).then((response) => {
      if (response.data.status) {
        this.content = response.data.colums
      }
    }).catch((response) => {
    })
  },
  methods: {
    showImg (src) {
      if (Object.keys(this.otherMap).length == 0) {
        this.$vux.alert.show({
          title: '暂无数据'
        })
        setTimeout(() => {
          this.$vux.alert.hide()
        }, 2000)
      } else {
        let imgSrc = this.otherMap['image' + src] + '?number=' + Math.random()
        let imgSrcArr = []
        imgSrcArr.push(imgSrc)
        wx.previewImage({
          current: imgSrc, // 当前显示图片的http链接
          urls: imgSrcArr // 需要预览的图片http链接列表
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/detail/todo/defaultTodo.vue